document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.im-gallery').forEach(gal => {

    const track = gal.querySelector('.im-gallery__track');

    if (! track) return;

    const items = Array.from(gal.querySelectorAll('.im-gallery-item'));
    const navItems = gal.querySelector('.im-gallery__buttons') ? Array.from(gal.querySelector('.im-gallery__buttons').children) : false;

    items[0].dataset.start = '';
    setTimeout(() => delete items[0].dataset.start);

    function go(index) {
      pauseAll();
      const offsetX = (items[index].offsetLeft - ((window.innerWidth - items[index].offsetWidth) / 2)) * -1;
      track.style.left = offsetX + 'px';
      for (let i = 0; i < items.length; i++) {
        items[i].hidden = index !== i;
        if (navItems) {
          setTimeout(() => {
            navItems[i].setAttribute('aria-selected', String(index === i));
          }, 50);
        }
      }
    }

    function prev() {
      const prevIndex = items.findIndex(el => ! el.hidden) - 1;
      go(prevIndex < 0 ? items.length - 1 : prevIndex);
    }

    function next() {
      const nextIndex = items.findIndex(el => ! el.hidden) + 1;
      go(nextIndex >= items.length ? 0 : nextIndex);
    }

    function loadVideoSource(video) {
      if (!video || video.dataset.loaded) return;
      video.querySelectorAll('source[data-src]').forEach(source => {
        source.src = source.dataset.src;
      });
      video.load();
      video.dataset.loaded = 'true';
    }

    function pauseAll() {
      for (let i = 0; i < items.length; i++) {
        const video = items[i].querySelector('.im-gallery-item__video');
        if (video) {
          video.pause();
          video.controls = false;
        }
        items[i].classList.remove('im-gallery-item--playing');
        gal.classList.remove('im-gallery--playing');
      }
    }

    function play(index) {
      for (let i = 0; i < items.length; i++) {
        const video = items[i].querySelector('.im-gallery-item__video');
        const image = items[i].querySelector('.im-gallery-item__image');
        if (i == index) {
          if (video) {
            loadVideoSource(video);
            video.play();
            video.controls = true;
          }
          items[i].classList.add('im-gallery-item--playing');
          if (image) image.remove();
        } else {
          if (video) {
            video.pause();
            video.controls = false;
          }
          items[i].classList.remove('im-gallery-item--playing');
        }
        gal.classList.add('im-gallery--playing');
      }
    }

    if (items) {
      items.forEach(el => {
        const overlay = el.querySelector('.im-gallery-item__overlay');
        if (overlay) {
          overlay.addEventListener('click', (e) => {
            play(items.indexOf(el));
            e.preventDefault();
          });
        }
      });
    }

    if (navItems) {
      navItems.forEach(el => {
        el.addEventListener('click', (e) => {
          go(navItems.indexOf(el));
          el.dataset.clicked = '';
          e.preventDefault();
        });
        // el.addEventListener('mouseover', (e) => {
        //   go(navItems.indexOf(el));
        //   el.dataset.clicked = '';
        //   e.preventDefault();
        // });
        el.addEventListener('animationend', next);
      });
    }

    if (gal.querySelector('.im-gallery__nav-button--next')) {
      gal.querySelector('.im-gallery__nav-button--next').addEventListener('click', (e) => {
        next();
      });
    }

    if (gal.querySelector('.im-gallery__nav-button--prev')) {
      gal.querySelector('.im-gallery__nav-button--prev').addEventListener('click', (e) => {
        prev();
      });
    }

    document.addEventListener('keydown', function(event) {
      if (event.key === 'ArrowRight') {
        next();
        event.preventDefault();
      } else if (event.key === 'ArrowLeft') {
        prev();
        event.preventDefault();
      }
    });

    let touchstartX = 0;
    let touchstartY = 0;
    let touchendX = 0;
    let touchendY = 0;

    function handleGesture(touchstartX, touchstartY, touchendX, touchendY) {
        const delx = touchendX - touchstartX;
        const dely = touchendY - touchstartY;
        if(Math.abs(delx) > Math.abs(dely)){
            if(delx > 0) return "right"
            else return "left"
        }
        else if(Math.abs(delx) < Math.abs(dely)){
            if(dely > 0) return "down"
            else return "up"
        }
        else return "tap"
    }

    gal.addEventListener('touchstart', function(event) {
        touchstartX = event.changedTouches[0].screenX;
        touchstartY = event.changedTouches[0].screenY;
    }, false);

    gal.addEventListener('touchend', function(event) {
        touchendX = event.changedTouches[0].screenX;
        touchendY = event.changedTouches[0].screenY;
        let direction = handleGesture(touchstartX, touchstartY, touchendX, touchendY);
        if (direction == 'left') {
          next();
        } else if (direction == 'right') {
          prev();
        }
    }, false);

    go(0);


  });
});
